import { injectGlobal } from 'styled-components'

import { resetCSS } from './module/reset-css'
import { colors } from './module/colors'

injectGlobal`
  ${resetCSS}
  *, *:before, *:after {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0,0,0,0);    
  }  
  html, body {
    width: 100%;
  }  
  body {
    font-family: sans-serif;
    background: ${colors.appBackground};
  }
  #root {
    width: 100%;
    display: flex;
    flex-direction: column;    
  }
`



// WEBPACK FOOTER //
// ./src/global-styles.js